import { render } from "./ConfirmJourney.vue?vue&type=template&id=19697362&scoped=true&lang=pug"
import script from "./ConfirmJourney.vue?vue&type=script&lang=ts"
export * from "./ConfirmJourney.vue?vue&type=script&lang=ts"

import "./ConfirmJourney.vue?vue&type=style&index=0&id=19697362&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-19697362"

export default script